var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _rect, _path4, _path5, _circle7, _circle8, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatMystery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#f0eee8",
    stroke: "#e0ddd5",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 28,
    r: 14,
    fill: "#8B7355",
    stroke: "#6B5535",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 26,
    r: 2.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 26,
    r: 2.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 26.5,
    r: 1.2,
    fill: "#2a2a2a"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 26.5,
    r: 1.2,
    fill: "#2a2a2a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 32 Q40 35 44 32",
    stroke: "#6B5535",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18 Q30 12 35 16",
    stroke: "#6B5535",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 18 Q50 12 45 16",
    stroke: "#6B5535",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 10,
    width: 28,
    height: 20,
    rx: 14,
    fill: "none",
    stroke: "#5C4033",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25 Q24 30 28 32",
    stroke: "#5C4033",
    strokeWidth: 1.5,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 48 Q22 42 28 40 L40 38 L52 40 Q58 42 58 48 L58 62 Q55 65 40 65 Q25 65 22 62 Z",
    fill: "#2a2a5a",
    stroke: "#1a1a4a",
    strokeWidth: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 52,
    r: 3,
    fill: "#e0c060"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 52,
    r: 3,
    fill: "#e0c060"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58 Q40 61 44 58",
    stroke: "#e0c060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38 Q26 34 30 32",
    stroke: "#2a2a5a",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52 38 Q54 34 50 32",
    stroke: "#2a2a5a",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatMystery);
export default __webpack_public_path__ + "static/media/cat-mystery.0470cc61ff1c97161f760e45c05a110e.svg";
export { ForwardRef as ReactComponent };